import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import RemoveIcon from '@mui/icons-material/Remove';
import { Box, Button, CircularProgress, IconButton, TextField, Typography } from '@mui/material';
import { useCartStore } from '../../../stores/cartStore';

const CartItem = ({ id, quantity, name, image, limit }) => {
  const setQuantity = useCartStore((state) => state.setQuantity);
  const removeItem = useCartStore((state) => state.removeItem);

  return (
    <Box
      sx={{ padding: '20px', borderRadius: '8px', backgroundColor: 'white', position: 'relative' }}
    >
      <Box
        sx={(theme) => ({
          display: 'grid',
          gridTemplateColumns: '100px 1fr',
          gap: '10px',
          alignItems: 'center',

          [theme.breakpoints.up('md')]: {
            gridTemplateColumns: '200px 1fr',
          },
        })}
      >
        {/* Reward Image */}
        {!image && !name ? (
          <CircularProgress sx={{ display: 'block', margin: '20px auto' }} />
        ) : (
          <Box
            component={'img'}
            src={image}
            alt="Reward"
            sx={{
              display: 'block',
              margin: '0 auto 10px',
              width: '100%',
              maxHeight: '90px',
              objectFit: 'contain',
            }}
          />
        )}

        {/* Reward Info */}
        <Box>
          <Typography
            align="center"
            sx={{
              fontSize: '1.5rem',
              lineHeight: 1,
              color: '#005972',
              fontWeight: '600',
              marginBottom: '10px',
            }}
          >
            {name}
          </Typography>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: '10px',
              maxWidth: '300px',
              margin: '10px auto',
            }}
          >
            <ChangeQtyButton onClick={() => setQuantity(id, quantity - 1)} disabled={quantity <= 1}>
              <RemoveIcon />
            </ChangeQtyButton>
            <Box sx={{ width: 'calc(100% - 60px)' }}>
              <TextField
                fullWidth
                placeholder="ระบุจำนวน"
                value={quantity}
                inputProps={{
                  autoComplete: 'off',
                  readOnly: true,
                  style: { textAlign: 'center' },
                }}
                sx={{
                  border: '2px solid #005972',
                  borderRadius: '8px',

                  '& .MuiInputBase-root': {
                    borderRadius: '8px',
                  },

                  '& .MuiInputBase-input': {
                    fontSize: '1.5rem',
                    padding: '5px 10px',
                    height: '25px',
                  },

                  '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                  },
                }}
              />
            </Box>
            <ChangeQtyButton
              onClick={() => setQuantity(id, quantity + 1)}
              disabled={limit && quantity >= limit}
            >
              <AddIcon />
            </ChangeQtyButton>
            <IconButton
              sx={{ position: 'absolute', top: '0', right: '0' }}
              onClick={() => removeItem(id)}
            >
              <CloseIcon sx={{ fontSize: '16px', color: '#333' }} />
            </IconButton>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const ChangeQtyButton = ({ onClick, disabled, children }) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      sx={{
        width: 30,
        minWidth: 'unset',
        height: 30,
        minHeight: 'unset',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        color: 'white',
        backgroundColor: '#FF0000',
        fontSize: '1rem',
        padding: 0,

        '&:hover': {
          backgroundColor: '#FF0000',
        },

        '&.Mui-disabled': {
          backgroundColor: '#fafafa',
        },
      }}
    >
      {children}
    </Button>
  );
};

export default CartItem;
